module.exports = __webpack_public_path__ + "eb899ebb266ad9cb6130bc5fcd436758.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/apple_2021_chart.png
// module id = 1630
// module chunks = 0